module.exports = __webpack_public_path__ + "img/Almaty.06d57777.png";